/**
 * Classifica a resposta de GET …/me/product-entitlement.
 * Somente HTTP 200 com payload habilitado/desabilitado define contratação.
 * 403 ≠ não contratado; 404/5xx ≠ não contratado.
 */
export const classifyEntitlementResponse = ({
  ok,
  status,
  data,
  unavailable,
  error,
} = {}) => {
  if (unavailable && !status) {
    return {
      kind: "unavailable",
      enabled: false,
      entitlement: null,
      error: error || "Breakage API não configurada",
    };
  }

  if (ok && data && typeof data.enabled === "boolean") {
    return {
      kind: data.enabled ? "enabled" : "disabled",
      enabled: Boolean(data.enabled),
      entitlement: data,
      error: null,
    };
  }

  if (status === 401) {
    return {
      kind: "unauthorized",
      enabled: false,
      entitlement: null,
      error: "Autenticação inválida ou expirada para consultar o Breakage.",
    };
  }

  if (status === 403) {
    return {
      kind: "forbidden",
      enabled: false,
      entitlement: null,
      error:
        "Acesso não permitido a este entitlement (permissão ou Owner único ausente).",
    };
  }

  if (status === 404) {
    return {
      kind: "unavailable",
      enabled: false,
      entitlement: null,
      error:
        "Rota de entitlement não encontrada. Verifique a integração com a API Breakage.",
    };
  }

  if (status === 503 || (status >= 500 && status < 600)) {
    return {
      kind: "unavailable",
      enabled: false,
      entitlement: null,
      error: error || "Serviço Breakage temporariamente indisponível.",
    };
  }

  return {
    kind: "unavailable",
    enabled: false,
    entitlement: null,
    error: error || "Não foi possível verificar o entitlement Breakage.",
  };
};

/** POST /balance-lots/search exige ao menos um filtro cadastral no body. */
export const hasCadastralBalanceLotFilter = ({
  participantId,
  legalName,
  documentNumber,
} = {}) =>
  Boolean(
    (participantId && String(participantId).trim()) ||
      (legalName && String(legalName).trim()) ||
      (documentNumber && String(documentNumber).trim())
  );

/**
 * Body JSON dos filtros da pesquisa de BalanceLots.
 * Paginação (limit/cursor) vai na query string — nunca no body.
 */
export const buildBalanceLotsSearchBody = ({
  participantId,
  legalName,
  documentNumber,
  eligibility,
  agingCondition,
  expiresFrom,
  expiresTo,
  creditedFrom,
  creditedTo,
} = {}) => {
  const body = {};
  if (participantId) body.participantId = String(participantId).trim();
  if (legalName) body.legalName = String(legalName).trim();
  if (documentNumber) body.documentNumber = String(documentNumber).trim();
  if (eligibility) body.eligibility = eligibility;
  if (agingCondition) body.agingCondition = agingCondition;
  if (expiresFrom) body.expiresFrom = expiresFrom;
  if (expiresTo) body.expiresTo = expiresTo;
  if (creditedFrom) body.creditedFrom = creditedFrom;
  if (creditedTo) body.creditedTo = creditedTo;
  return body;
};

/** Query params de paginação do POST /balance-lots/search. */
export const buildBalanceLotsSearchPageParams = ({ limit = 50, cursor } = {}) => ({
  limit,
  ...(cursor ? { cursor } : {}),
});

/**
 * Query params seguros para GET /balance-lots.
 * Nunca inclui documentNumber (410), filter nem asOf (400).
 */
export const buildBalanceLotsListParams = ({
  limit,
  cursor,
  participantId,
  legalName,
  eligibility,
  agingCondition,
  expiresFrom,
  expiresTo,
  creditedFrom,
  creditedTo,
} = {}) => {
  const params = {};
  if (limit != null) params.limit = limit;
  if (cursor) params.cursor = cursor;
  if (participantId) params.participantId = String(participantId).trim();
  if (legalName) params.legalName = String(legalName).trim();
  if (eligibility) params.eligibility = eligibility;
  if (agingCondition) params.agingCondition = agingCondition;
  if (expiresFrom) params.expiresFrom = expiresFrom;
  if (expiresTo) params.expiresTo = expiresTo;
  if (creditedFrom) params.creditedFrom = creditedFrom;
  if (creditedTo) params.creditedTo = creditedTo;
  return params;
};
